import { WhatsAppHelpLink } from '../../Configs/Links';
import { PortalCheck } from '../../Configs/general';
import { WADefaultMessage } from '../enums';

export const OpenNewTab = url => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const WhatsAppHelpLinkHandler = () => {
  const chatMessage = WADefaultMessage();

  const url = PortalCheck.isGascaribe
    ? `${WhatsAppHelpLink}&text=${chatMessage}`
    : WhatsAppHelpLink;
  OpenNewTab(url);
};

// Safari drops user-activation after an awaited call, so window.open/click-based
// new tabs get silently blocked. Only use this for links opened right after an
// async action (like an API call), plain click handlers should keep using OpenNewTab.
export const OpenLinkAfterAsyncAction = url => {
  if (!url) {
    return;
  }

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    window.location.href = url;
  } else {
    OpenNewTab(url);
  }
};
